// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__2Z2Xm","Image":"Spinner_Image__2rgoY","load":"Spinner_load__3_jqs"};